import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=b5c068b0&scoped=true&lang=pug"
import script from "./Extras.vue?vue&type=script&lang=ts"
export * from "./Extras.vue?vue&type=script&lang=ts"
import style0 from "./Extras.vue?vue&type=style&index=0&id=b5c068b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c068b0",
  null
  
)

export default component.exports